import { useState } from "react";

export interface Preferences {
  highContrast: boolean;
  reducedMotion: boolean;
  sound: boolean;
  volume: number;
}
const defaults: Preferences = {
  highContrast: false,
  reducedMotion: false,
  sound: false,
  volume: 0.25,
};
export function usePreferences() {
  const [preferences, setPreferences] = useState<Preferences>(() => {
    try {
      const stored = JSON.parse(
        localStorage.getItem("tcp:preferences") || "null",
      );
      return stored &&
        typeof stored.highContrast === "boolean" &&
        typeof stored.reducedMotion === "boolean" &&
        typeof stored.sound === "boolean" &&
        typeof stored.volume === "number" &&
        stored.volume >= 0 &&
        stored.volume <= 1
        ? stored
        : defaults;
    } catch {
      return defaults;
    }
  });
  const updatePreferences = (next: Preferences) => {
    setPreferences(next);
    try {
      localStorage.setItem("tcp:preferences", JSON.stringify(next));
    } catch {
      /* preferences remain usable for this session */
    }
  };
  return [preferences, updatePreferences] as const;
}

/** Short synthetic, non-graphic status cue. Silent by default; no downloaded audio. */
export function playStatusCue(volume: number) {
  const context = new AudioContext();
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = "sine";
  oscillator.frequency.value = 440;
  gain.gain.setValueAtTime(0, context.currentTime);
  gain.gain.linearRampToValueAtTime(volume * 0.15, context.currentTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.18);
  oscillator.connect(gain);
  gain.connect(context.destination);
  const close = () => {
    if (context.state !== "closed") void context.close().catch(() => {});
  };
  const cleanup = window.setTimeout(close, 1000);
  void context.resume().catch(close);
  oscillator.start();
  oscillator.stop(context.currentTime + 0.2);
  oscillator.onended = () => {
    window.clearTimeout(cleanup);
    close();
  };
}
